import { render, staticRenderFns } from "./ReviewCreatedCount.vue?vue&type=template&id=ca229a78"
import script from "./ReviewCreatedCount.vue?vue&type=script&lang=js"
export * from "./ReviewCreatedCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports